import { makeStyles } from '@material-ui/core/styles';
import creationModeEnum from '../../../../models/creationModeEnum';

const iconDefault = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
};

const useStyles = makeStyles((theme) => ({
  immediateIcon: {
    ...iconDefault,
    color: theme.palette.findingType.immediate,
  },
  investigateIcon: {
    ...iconDefault,
    color: theme.palette.findingType.investigation,
  },
  noteIcon: ({ creationMode }) => ({
    ...iconDefault,
    color: creationMode === creationModeEnum.automatic ? theme.palette.findingType.noteAutomatic : theme.palette.findingType.noteManual,
  }),
  dismissedIcon: {
    ...iconDefault,
    color: theme.palette.findingType.dismissed,
  },
  unclassifiedIcon: {
    ...iconDefault,
    color: theme.palette.findingType.unclassified,
  },
  priorityLabel: {
    marginLeft: '0.5rem',
  },
}));

export default useStyles;
